import { get } from "lodash";
import { dateFormat, dayAgo, isValidArray } from "../../helper";
import { ISSUE_STATUS } from "../../constant";
import React from "react";
import htmlToFormattedText from "html-to-formatted-text";

export const modifyDataForPost = data => {
  let cleanText = get(data, "comment")
    .replace(/(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*){2,}/gi, "<p><br></p>")
    .replace(/^(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*)+/gi, "")
    .replace(/(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*)+$/gi, "");

  return {
    //comment: htmlToFormattedText(get(data, "comment")),
    comment: cleanText,
    fids: get(data, "files", []).map(value => {
      return +value.id;
    }),
    issueId: get(data, "id"),
    tentativeResolutionDate: get(data, "modifyDate")
      ? get(data, "modifyDate")
      : null
  };
};

export const modifyDataForDuplicate = data => {
  return {
    comment: htmlToFormattedText(get(data, "comment")),
    fids: get(data, "files", []).map(value => {
      return +value.id;
    }),
    duplicate: get(data, "id"),
    original: get(data, "originalId")
  };
};

export const modifyDataForForwardToTeam = data => {
  console.log("helper.js", data);
  let cleanText = get(data, "comment")
    .replace(/(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*){2,}/gi, "<p><br></p>")
    .replace(/^(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*)+/gi, "")
    .replace(/(?:\s*<p>\s*(?:<br\s*\/?>)?\s*<\/p>\s*)+$/gi, "");

  return {
    categoryId: get(data, "category", null) && +get(data, "category"),
    //description: htmlToFormattedText(get(data, 'comment')),
    description: cleanText,
    fids: get(data, "files", []).map(value => {
      return +value.id;
    }),
    groupId: get(data, "to") && +get(data, "to"),
    issueId: get(data, "id") && +get(data, "id"),
    subCategoryId: get(data, "subCategory") && +get(data, "subCategory"),
    title: htmlToFormattedText(get(data, "title"))
  };
};

export const shouldDisplayIssueAction = actionsInfo => {
  return !!(
    get(actionsInfo, "addComment") ||
    get(actionsInfo, "addMoreIssue") ||
    get(actionsInfo, "clarification") ||
    get(actionsInfo, "forwardToTeam") ||
    get(actionsInfo, "reply") ||
    get(actionsInfo, "addDecision") ||
    get(actionsInfo, "edit") ||
    !!(get(actionsInfo, "actions") && get(actionsInfo, "actions").length) ||
    get(actionsInfo, "unHold") ||
    !!(
      get(actionsInfo, "forwardToTeamList") &&
      get(actionsInfo, "forwardToTeamList").length
    )
  );
};

export const getIssueStatus = issueDetails => {
  let isNotAssignedTo =
    get(issueDetails, "status") === ISSUE_STATUS.REJECT ||
    get(issueDetails, "status") === ISSUE_STATUS.RESOLVED ||
    get(issueDetails, "status") === ISSUE_STATUS.REJECTED ||
    get(issueDetails, "status") === ISSUE_STATUS.HOLD ||
    get(issueDetails, "status") === ISSUE_STATUS.reject ||
    get(issueDetails, "status") === ISSUE_STATUS.resolved ||
    get(issueDetails, "status") === ISSUE_STATUS.hold ||
    get(issueDetails, "status") === ISSUE_STATUS["On Hold"];

  let isRejected =
    get(issueDetails, "status") === ISSUE_STATUS.REJECT ||
    get(issueDetails, "status") === ISSUE_STATUS.reject ||
    get(issueDetails, "status") === ISSUE_STATUS.REJECTED;

  let isResolved =
    get(issueDetails, "status") === ISSUE_STATUS.RESOLVED ||
    get(issueDetails, "status") === ISSUE_STATUS.resolved;

  let obj = isNotAssignedTo
    ? isRejected
      ? { heading: "Rejected by", getDataFrom: "issueStatusChangeGroup" }
      : isResolved
      ? { heading: "Resolved by", getDataFrom: "issueStatusChangeGroup" }
      : { heading: "On Hold by", getDataFrom: "issueStatusChangeGroup" }
    : { heading: "Assigned to", getDataFrom: "assigneeGroup" };

  return (
    <React.Fragment>
      {obj.heading} <span>{get(issueDetails, obj.getDataFrom)}</span>
    </React.Fragment>
  );
};

export const getIssueAssigneeDate = issueDetails => {
  let isStatusNotAssigned =
    get(issueDetails, "status") === ISSUE_STATUS.REJECT ||
    get(issueDetails, "status") === ISSUE_STATUS.RESOLVED ||
    get(issueDetails, "status") === ISSUE_STATUS.HOLD ||
    get(issueDetails, "status") === ISSUE_STATUS.reject ||
    get(issueDetails, "status") === ISSUE_STATUS.resolved ||
    get(issueDetails, "status") === ISSUE_STATUS.REJECTED ||
    get(issueDetails, "status") === ISSUE_STATUS.hold ||
    get(issueDetails, "status") === ISSUE_STATUS["On Hold"];

  return isStatusNotAssigned
    ? `on ${dateFormat(get(issueDetails, "issueStatusChangeDate"))}`
    : get(issueDetails, "lastAssigneeDate")
    ? dayAgo(get(issueDetails, "lastAssigneeDate"))
    : dayAgo(get(issueDetails, "createdDate"));
};

export const toolttipDisplayMessage = issueStatus => {
  switch (issueStatus) {
    case "Pending with SM":
      return "Pending with Sponsoring Ministry for Review";
    case "Pending with PMG":
      return "Pending with PMG team for final Verification";
    case "Pending with RM/RS":
      return "Pending with Recipient Ministry/State for Resolution";
    case "Under PMG Decision":
      return "Pending with PMG Team for confirmation on Resolution";
    case "Resolved":
      return "Issue Resolved";
    case "Rejected":
      return "Issue Rejected";
    case "On Hold":
      return "Issue put on Hold";
    case "Pending with SS":
      return "Pending with State for Verification";
    case "Pending with SPMG/SD":
      return "Pending with State PMG Team/Sponsoring Department for Verification";
    case "Pending with RD":
      return "Pending with Recipient District/Department for Resolution";
    case "Under State PMG Decision":
      return "Pending with State PMG Team for confirmation on Resolution";
    case "Under Central PMG":
      return "Pending with Central PMG Team for Review";
    case "Assigned for Clarification":
      return "Clarification Requested";
  }
};
